import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { ResidentsPage } from '@/pages/v2/users';
import { Layout as ResidentLayout } from '@/pages/v2/users/components/layout';
import { ResidentPage } from '@/pages/v2/users/user';
import { RoleGuard } from '@/components/auth/guards/role-guard';
import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { ACCOUNT_ROLES } from '@/constants/account-roles';

export const route: RouteObject = {
  path: paths.users.index,
  element: (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          displayUnauthorized
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER]}
        >
          <ResidentsPage />
        </RoleGuard>
      ),
    },
    {
      path: paths.users.details(':userId'),
      element: (
        <RoleGuard
          displayUnauthorized
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER]}
        >
          <ResidentPage />
        </RoleGuard>
      ),
    },
  ],
};
